<template>
  <Dialog ref="p">
    <div class="dialog-content">
      <div class="icon"><img src="//cdn.hongbaoxd.com/images/2145639abc8f1db82c7ed954ea95464a.png" alt=""></div>
    </div>
  </Dialog>
</template>
<style lang='scss' scoped>
  .dialog-content {
    width: 295px;
    height: 289px;
    padding: 30px 0;
    text-align: center;

    .title {
      font-size: 18px;
      color: #3A3A3A;
      margin-bottom: 10px;

      @include semibold();
    }

    .sub-title {
      font-size: 13px;
      color: #3A3A3A;
      margin-bottom: 30px;

      @include regular();
    }

    .icon {
      height: 72px;
      text-align: center;
      margin-bottom: 30px;

      img {
        width: 72px;
        height: 72px;
      }
    }

    .receive {
      margin: 0 auto;
    }
  }
</style>
<script>
  import Dialog from './Dialog'
  export default {
    components: {
      Dialog
    },
    methods: {
      show () {
        this.$refs.p.show()
      },
      hide () {
        this.$refs.p.hide()
      }
    }
  }
</script>
